<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <div v-if="initialLoading" class="d-flex justify-content-center align-items-center min-height-200">
            <busy-spinner text="Loading..."></busy-spinner>
        </div>

        <div 
            v-else
            class=""
        >
            
            <div class="">  <!-- FORM AREA -->
                <div 
                    v-for="form in Object.values(formRegistry)" 
                    :key="form.name"
                    :class="form.formClass"
                >  <!-- Put the ref="" on the Vue element -- that's the one you want to work with, not the div -->
                    <h3 v-if="form.title" :class="form.titleClass">{{ form.title }}</h3>
                    <FormulateForm
                        :name="form.name"
                        :schema="form.schema" 
                        v-model="form.data"
                        ref="allForms"
                        @created="handleSingleFormCreated"
                        @input="handleSingleFormInput"
                        @submit="handleSingleFormSubmit"
                        @submit-raw="handleSingleFormSubmitRaw"
                        @failed-validation="handleSingleFormFailedValidation"
                    ></FormulateForm>
                </div>
                <!-- <div v-if="formData">
                    <h3>{{ formData.title }}</h3>
                </div> -->
                <!-- Do not show this component until you have the schema -->
                <!-- <formio-form
                    ref="formioFormComp"
                    v-if="formCanRender"
                    :schema="schema"
                    :submission-data="existingData"
                    :file-urls="fileUrls"
                    :form-options="formOptions"
                    :html-mode="htmlMode"
                    :read-only="readOnly"
                    :parent-id="taskId"
                    :parent="task"
                    :render-all-extras="formioRenderAllExtras"
                    @setup-complete="handleFormSetupComplete"
                    @change="handleFormChange"
                    @error="handleFormError"
                    @is-valid="handleFormIsValid"
                    @fishbone-image="handleFishboneImage"
                    class="mt-3"
                ></formio-form> -->
            </div>
            <div class="">
                <pre>{{ combinedData }}</pre>
            </div>

            <!-- <div 
                v-if="formSetupComplete"
                class="mt-4"
            >  
                <hr>
                <div
                    v-if="canTuSubmitForm"
                    key="formSubmitButtons"
                    class="d-flex gap-3 align-items-center justify-content-between"
                >
                    VALIDATION STATUS
                    <div class="">
                        <div 
                            v-if="!localIsValid"
                            key="formNotValid"
                            class="flex-shrink-1 text-left text-danger-400 font-size-70 font-weight-bold text-uppercase"
                        >
                            <b-icon icon="x-circle-fill" class="mr-1"></b-icon>
                            Form Incomplete
                        </div>
                    </div>
                    SUBMIT BUTTONS
                    <div class="d-flex gap-4 align-items-center justify-content-end">
                        <b-button 
                            v-if="showSaveDraftButton"
                            size="lg" 
                            variant="subtle-secondary"
                            class="min-width-150"
                            @click="submitDraft({showToast: true})"
                        >
                            <span v-if="loadingSave" key="loadingSave">
                                <b-spinner small></b-spinner>
                            </span>
                            <span v-else key="notLoadingSave">
                                Save Draft
                            </span>
                        </b-button>
                        <b-button 
                            v-if="showSavePartialSubmissionButton"
                            size="lg" 
                            variant="subtle-secondary"
                            class="min-width-150"
                            :disabled="disableSavePartialSubmissionButton"
                            @click="submitPartialForm({showToast: true})"
                        >  
                            <span v-if="loadingSave" key="loadingSave">
                                <b-spinner small></b-spinner>
                            </span>
                            <span v-else key="notLoadingSave">
                                Save Progress
                            </span>
                        </b-button>
                        <b-button 
                            v-if="showSaveCompleteSubmissionButton"
                            size="lg" 
                            variant="primary"
                            class="min-width-150"
                            :disabled="disableSaveCompleteSubmissionButton"
                            @click="submitCompleteForm({showToast: true})"
                        >  
                            <span v-if="loadingSave" key="loadingSave">
                                <b-spinner small></b-spinner>
                            </span>
                            <span v-else key="notLoadingSave">
                                Update Data
                            </span>
                        </b-button>
                    </div>
                </div>
                <div v-else key="hideSubmitButtons">
                    <div class="font-weight-bold text-uppercase text-muted font-size-80">
                        Read Only
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</template>

<script>
// This does the API calls around a Formio form -- not the actual rendering of the form

import { suppliosApi } from '../../js/api-service';
import { errorHandling, currentUserInfoMixin } from '../../js/custom-vue-mixins';
import cloneDeep from 'lodash/cloneDeep';
//import set from 'lodash/set';
import isEmpty from 'lodash/isEmpty';
import uniqueId from 'lodash/uniqueId';
import isObject from 'lodash/isObject';
import debounce from 'lodash/debounce';
//import merge from 'lodash/merge';

class RegisteredForm {
    constructor({name, schema, formClass, title, titleClass, initialData}) {
        // just pass through everything? 
        this.name = name;  // name of form so we can use named forms feature of FormulateForm
        this.schema = [...schema];  // array that we'll pass to FormulateForm :schema
        this.isValid = false;  // we'll update this as we check/get events
        this.formClass = formClass ?? '';
        this.title = title ?? '';
        this.titleClass = titleClass ?? '';
        this.data = cloneDeep(initialData);  // should we pull out only the things for this form????  at least de-couple it with cloneDeep
    }
}

export default {
    name: 'WorkflowFormulateMulti',
    components: {
    },
    mixins: [
        errorHandling,
        currentUserInfoMixin,
    ],
    props: {
        // task: {
        //     type: Object,
        //     required: true,
        // },
        displayMode: {
            type: String,
            default: 'input',  // options should be 'input' (form), 'display' (read-only form?), or 'report' (will default to something else if no report here)
        },
        schema: {  // could be a single formulate schema (array) OR multiple ones in an object, keyed by form name, or array of multiple schema arrays?
            type: [Array, Object],
            required: true,
        },
        submissionData: {  // data for ALL the forms here -- will have to separate it!
            type: Object,
            required: true,
        },
    }, 
    data: function() {
        return {
            // NEW STUFF FOR MULTIFORM
            initialLoading: false,
            combinedData: {},  // the local copy of submission data, as we are updating it - ALL FORMS MERGED - each form keeps their own, then we merge in here when they @input us
            formRegistry: {},  // { formName: schema[], ... } separated from schema prop
        }
    },
    computed: {
        // isActive() {
        //     return this.task?.sm_state === 'active';
        // },
        // isCompleted() {
        //     return this.task?.sm_state === 'completed';
        // },
        // currentStateCanEdit() {  // based on current state, can assignees edit?
        //     return this.task?.can_edit_data_now;  // OLD this.task?.state_dict?.assignee_can_edit;
        // },
        // canTuSubmitForm() {
        //     // gets from model method .can_tu_submit_form() which checks the TU in serializer
        //     return this.task?.can_tu_submit_form;  // this also checks task.can_edit_data_now on backend
        // },
        // showSaveDraftButton() {
        //     // should we show the 'Save Draft' or 'Save Progress' button?
        //     // only show if NOT YET COMPLETED -- because if its already completed, we really only want to deal with full updates all the way to submit, not saving drafts
        //     //return !this.isCompleted && this.canTuSubmitForm;
        //     // NEW Feb 21 2022 - added field 'allow_draft_submissions' (which is likely always false)
        //     // instead, we added 'allow_partial_submissions' -- will run through all things on form, only get the fields that have values and are valid, send that
        //     // that's basically like a draft... but data will get merged to workflow.meta (if needed) on backend
        //     const allowDrafts = this.task?.allow_draft_submissions;
        //     return allowDrafts && !this.isCompleted && this.canTuSubmitForm;
        // },
        // showSavePartialSubmissionButton() {
        //     // for showing the 'save progress' button
        //     // only allowed when backend says task.allow_partial_submissions (based on state of task, must not be completed)
        //     // must also check this.canTuSubmitForm
        //     // also, to avoid user confusion we will only show this when the form is NOT COMPLETED
        //     // otherwise, we'll show the saveCompleteSubmission button if task is already completed
        //     // this means user will only do partial submissions if they save progress, until they click on Complete Task, which submits full submission
        //     // make sure your backend and frontend validation are in sync!  otherwise save partial might get accepted, frontend shows all is valid, user tries to complete task then they get error from backend... not good
        //     return this.task?.allow_partial_submissions && !this.isCompleted && this.canTuSubmitForm;
        // },
        // disableSavePartialSubmissionButton() {
        //     // only applies when the save partial button is showing
        //     // don't have to check if its valid... because this will run through everything on form and ONLY save the things that have a value and are valid
        //     return false;  // for now just never disable it... we'll only check if we have any data when we click button because its expensive to calculate
        // },
        // showSaveCompleteSubmissionButton() {
        //     // should we show the 'Save & Submit' button?  
        //     // ONLY show this if TASK was already completed, but we are allowing edits outside of normal task 'active' state
        //     // because we'll show the Complete Task button instead, which will also submit the form first
        //     // OR we could only show this button, and make it complete the task... only one
        //     // OLD return this.isCompleted && this.canTuSubmitForm;
        //     // NEW - Feb 21 2022 - removing ability to save drafts for most things,
        //     //      instead, we'll show EITHER the savePartialSubmission button (if task is NOT YET COMPLETE)
        //     //          or we'll show this button if task is completed already, and form is valid 
        //     // allow user to save a submitted submission but not complete the task... that's basically like a draft, but without the confusion around which data is correct (especially when linked with workflow data - workflow.meta)
        //     return this.isCompleted && this.canTuSubmitForm;
        // },
        // disableSaveCompleteSubmissionButton() {
        //     // only applies whtn the saveCompleteSubmission button is showing
        //     // show the button but disable it when the data is not valid
        //     // we do not allow partial submissions if task is completed (for now)
        //     return !this.localIsValid;
        // },
        // assignedTuIds() {
        //     const assignedTus = this.task?.assigned_tus;
        //     if (assignedTus && Array.isArray(assignedTus)) {
        //         return this.task.assigned_tus.map(tu => tu.id);
        //     } else {
        //         return []
        //     }
        // },
        // currentTuIsAssignee() {
        //     return this.assignedTuIds.includes(this.$currentUserInfo.tenant_user_id);
        // },
    },
    watch: {
        combinedData: {
            handler: function() {
                // if we check validation right after @input, things are not settled yet on each form
                // so we'll watch things here, debounce too if needed
                this.debouncedUpdateIsValid();
            },
            deep: true,
        },
    },
    created() {
        this.debouncedUpdateIsValid = debounce(this.updateIsValid, 250);
        this.prepSchema();
        console.log('end of created');
    },
    beforeMount() {
        console.log('end of beforeMount');
    },
    async mounted() {
        //await this.getFormSchema();
        //await this.loadInitial();
        console.log('end of mounted() in multiform');
    },
    methods: {
        getFieldNames(schema) {
            // pass in a form schema (array, possibly with nested children) and return an array of field names on this form
            // must check recursively, in 'children' arrays also
            // will NOT include field names in group components -- only TOP LEVEL DATA field names
            const names = [];
            const isFormulateField = (fld) => {
                return !!fld && fld.name && !fld.component;  // has 'name' but not 'component', then its likely a formulate field object
            };
            const isGroupField = (fld) => {
                return isFormulateField(fld) && !!fld.type && (fld.type == 'group');
            }
            const addFieldName = (fld) => {
                if (isFormulateField(fld)) {
                    names.push(fld.name);
                }
                if (fld?.children && Array.isArray(fld.children)) {
                    if (isGroupField(fld)) {
                        return;  // we don't want to add child components here... only top level
                    }
                    fld.children.forEach(childFld => addFieldName(childFld));
                }
            };
            if (schema && Array.isArray(schema)) {
                schema.forEach(fld => addFieldName(fld));
            }
            return names;
        },
        getSubmissionDataForFields(fieldNames) {
            // pass in array of fieldNames, return subset of this.submissionData object with just those fields
            if (!fieldNames || !Array.isArray(fieldNames) || fieldNames.length < 1) {
                return;
            }
            const subData = {};
            Object.entries(this.submissionData).forEach(([fldName, fldVal]) => {
                if (fieldNames.includes(fldName)) {
                    subData[fldName] = cloneDeep(fldVal);  // we want to clone it... not sure if its array?  object?  string?
                }
            });
            return subData;
        },
        prepSchema() {
            // figure out what kinda of schema we have, then prep formRegistry
            console.log('prepSchema');
            const registeredForms = [];
            if (!this.schema) {
                console.log('no schema');
                return;
            } else if (Array.isArray(this.schema) && this.schema.length) {
                console.log('schema is array');
                // array of objects? 
                //      if 'schema' is in keys, then each object is a separate form
                //      if not, then its a formulate schema itself
                // array of arrays?  then its a list of schemas
                const first = this.schema[0];
                if (first && Array.isArray(first)) {
                    console.log('array of arrays');
                    // handle array of schema arrays - create names for each, since they don't have them
                    this.schema.forEach(sch => {
                        const fieldNames = this.getFieldNames(sch);
                        const initialData = this.getSubmissionDataForFields(fieldNames);
                        const regForm = new RegisteredForm({name: uniqueId('form_'), schema: [...sch], initialData: initialData});
                        registeredForms.push(regForm);
                    });
                } else {
                    console.log('not array of arrays');
                    // handle array of objects -- objects could be a form (with name, schema, etc.) or fields in one schema
                    const isFormObjects = this.schema.every(sObj => !!sObj.schema);  // each one have 'schema' attr itself?
                    if (isFormObjects) {
                        console.log('we have formOBJECTS in array');
                        // handle an aray of form objects -- each with attributes { name, schema, title, classes, ...maybe more... }
                        this.schema.forEach(formObj => {
                            const formObjSchema = formObj.schema;
                            const fieldNames = this.getFieldNames(formObjSchema);
                            const initialData = this.getSubmissionDataForFields(fieldNames);
                            const regFormParams = {
                                ...formObj,  // pass everything straight on through... 
                                initialData: initialData,
                            };
                            const regForm = new RegisteredForm(regFormParams);
                            registeredForms.push(regForm);
                        });
                    } else {
                        console.log('array of fields - single schema/form');
                        // handle a single array of objects... objects are fields, only one form here
                        const fieldNames = this.getFieldNames(this.schema);
                        const initialData = this.getSubmissionDataForFields(fieldNames);
                        const regForm = new RegisteredForm({name: 'the_form', schema: [...this.schema], initialData: initialData});
                        registeredForms.push(regForm);
                    }
                }
            } else if (isObject(this.schema) && Object.values(this.schema).every(schVal => Array.isArray(schVal))) {
                console.log('schema is object');
                // isObject can be true for lots of things... should have object with keys being name of form, values being array schemas
                // hence we are checking all the values are arrays also
                Object.entries(this.schema).forEach(([formName, schemaArray]) => {
                    const fieldNames = this.getFieldNames(schemaArray);
                    const initialData = this.getSubmissionDataForFields(fieldNames);
                    console.log(`initialData for form ${formName}`, initialData);
                    const regForm = new RegisteredForm({name: formName, schema: [...schemaArray], initialData: initialData});
                    registeredForms.push(regForm);
                });
            } else {
                console.log('not sure what the heck schema is');
            }
            registeredForms.forEach(regForm => {
                this.$set(this.formRegistry, regForm.name, regForm);
            });
        },
        allFormRefs() {
            // get all the forms as refs - will always be an array, even if none (empty array in that case)
            return this.$refs['allForms'] ? this.$refs['allForms'] : [];
        },
        updateIsValid() {
            // run through each form, check its validation, and update it in registry
            // we'll get stuff from each one's .formContext -- seems safest?  its part of the API
            this.allFormRefs().forEach(form => {
                const hasErrors = form.hasErrors;
                const formName = form.name;  // from the prop 
                console.log(`${formName} hasErrors?`, hasErrors);
            });
        },
        handleSingleFormInput(payload) {
            console.log('input', payload);
            const dataCopy = cloneDeep(this.combinedData);
            this.combinedData = Object.assign(dataCopy, payload);  // clone payload too?
            // this.$nextTick(() => {
            //     this.updateIsValid();
            // });
        },
        handleSingleFormSubmit(payload) {
            console.log('submit', payload);
        },
        handleSingleFormSubmitRaw(payload) {
            console.log('submit-raw', payload);
        },
        handleSingleFormCreated(payload) {
            console.log('created', payload);
        },
        handleSingleFormFailedValidation(payload) {
            console.log('failed-validation', payload);
        },
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        // async loadInitial() {
        //     this.initialLoading = true;
        //     try {
        //         // fetches the schema and any existing submissions for this task from our backend
        //         const { data } = await suppliosApi.workflowTask.get_form_data(this.taskId);
        //         // will have { task, form_version, form, workflow_context, files } full objects
        //         this.setTask(data.task);
        //         this.setFiles(data.files);
        //         this.setSchema(data.form_version, data.task, data.workflow_context);
        //         this.setFormVersionData(data.form_version);
        //         this.setFormData(data.form);
        //         this.formCanRender = true;
        //     } catch (err) {
        //         this.apiErrorHandler(err);
        //     }
        //     this.initialLoading = false;
        // },
        // setTask(taskObj) {
        //     // pull out any things you need, and set this.task
        //     this.task = taskObj;  // watch out for using computeds that are based on this... may need nextTick
        //     // ALSO - replace file URLs, and any other prep-work for the submission data before passing to actual form
        //     // FEB 23 2022 - we now get ALL files in the workflow, handle them separately, not here
        //     //const taskFiles = taskObj.files ?? [];  // array of any task files
        //     //const filesById = Object.fromEntries(taskFiles.map(file => ([ file.id, file.download_url ])));  // pull out the download_url, to replace the one stored in form submission data as 'url'
        //     //this.fileUrls = Object.assign({}, filesById);
        //     // then we pass this.fileUrls to the child formio-form component, which replaces them for the old URLs when it sets submission
        //     console.log('from setTask, here is taskObj', taskObj);
        //     /* let submittedData = cloneDeep((taskObj.data ?? {}));  // we MUTATE this below...
        //     const draftData = taskObj.draft_data ?? {};  // don't need to cloneDeep... not mutating this one in merge
        //     this.existingData = merge(submittedData, draftData); */
        //     // NEW - based on task submission objects now, with draft/submitted already merged on the backend
        //     this.existingData = cloneDeep(taskObj.submission_data);
        //     // TODO - come back to this once you know how to handle things on backend
        //     // ALSO - figure out what state the form should be in
        //     // if not yet completed but current TU cannot edit, display it as read-only
        //     // if not yet completed but current TU CAN edit, show it as normal form
        //     // if IS completed, but TU CAN edit, then we're allowing edits in extra states, so show as normal form (NEW on Feb 18 2022)
        //     // and for now we are NOT USING htmlMode -- just always keep it false for now -- it displays things strangely
        //     this.htmlMode = false;  // always for now
        //     this.readOnly = !this.canTuSubmitForm;
        // },
        // setFiles(fileList) {
        //     // we get an array of ALL the TaskFiles in the workflow - maybe later we'll get only the ones we need
        //     if (fileList && Array.isArray(fileList)) {
        //         this.workflowFiles = fileList;  // stash it so we can pass to report component too
        //         const filesById = Object.fromEntries(fileList.map(file => ([ file.id, file.download_url ])));  // pull out the download_url, to replace the one stored in form submission data as 'url'
        //         this.fileUrls = Object.assign({}, filesById);
        //     } else {
        //         this.fileUrls = {};
        //         this.workflowFiles = [];
        //     }
        // },
        // setSchema(formVersionData, taskData, workflowContext) {
        //     // set the final schema we pass to the form -- we will merge some things together
        //     // in future, you may want to do this on backend for more consistency across form components?
        //     const schema = cloneDeep(formVersionData.schema);
        //     // now add in the full task object, also under 'customData' - don't replace entire customData key in schema... you'll likely already have things there - use lodash set
        //     const taskDataClone = cloneDeep(taskData);  // we clone in it case it get's mutated in here, we don't want to screw up the form -- form will only take the original task data
        //     set(schema, 'customData.task', taskDataClone);
        //     const workflowContextClone = cloneDeep(workflowContext);
        //     set(schema, 'customData.workflow_context', workflowContextClone);
        //     this.schema = schema;
        // },
        // setFormVersionData(formVersionData) {
        //     // set local data from API response
        //     // MOVED TO SEPARATE METHOD - this.schema = formVersionData.schema;
        //     this.formVersionData = formVersionData;
        // },
        // setFormData(formData) {
        //     // set local data from API response
        //     this.formData = formData;
        // },
        // handleFormChange(newData) {
        //     // 'change' event emits changed payload - includes { changed, data, isValid }
        //     // but we are now just passing in the 'data' part of it -- other stuff seems unreliable
        //     // changed is info about the component that changed, data is the overall submission data, isValid is validity of that data
        //     //const { data, isValid } = formChangedPayload;  
        //     // just update our local copy 
        //     this.currentSubmissionData = newData;  // clone it?  use formio fast cloneDeep?
        //     //this.localIsValid = isValid;
        // },
        // handleFormError() {  // errors - not using payload so ignore it for now
        //     // handler from formio-formm component
        //     console.log('from handleFormError');
        // },
        // handleFormIsValid(isValid) {
        //     // handler from formio-formm component - $emit to parent also!
        //     this.localIsValid = isValid;
        //     this.$emit('is-valid', isValid);
        // },
        // handleFormSetupComplete() {
        //     // from @setup-complete event from formio-form component - your own event to tell this component the form is ready to go
        //     console.log('Formio form is ready to go');
        //     this.formSetupComplete = true;
        // },
        // getFormioFormRef() {
        //     // return the FormioForm component ref, will be undefined if we can't find it
        //     return this.$refs['formioFormComp'];
        // },
        async submitOnTaskCompleted() {
            // CALLED FROM PARENT - WorkflowTask - just call the needed method here
            // parent expects to return success boolean
            return await this.submitCompleteForm();
        },
        async submitCompleteForm({showToast = false} = {}) {  // CAN ALSO CALL THIS FROM PARENT USING REF! - maybe ONLY from parent... maybe only have 'save draft' on this one
            // call validation method first?
            // GRAB FORM DATA BEFORE STARTING LOADING -- loading will destroy form in child component???
            // UPDATED Feb 23 2022 - not just using the submission data from formio events -- grabbing it ourselves so we can ignore read-only (disabled fields, etc.)
            // GRAB FORM DATA BEFORE STARTING LOADING -- loading will destroy form in child component???
            // must get PARTIAL data here from FormioForm component -- we'll only get it when called, because it might be expensive
            const formComp = this.getFormioFormRef();
            const isValid = formComp ? formComp.checkValidationBeforeCompleteSubmit() : false;
            if (!isValid) {
                console.log('form is not valid');
                await this.showBlockedSubmitMessage('Some items in this form are not valid.  Please correct the errors.');
                return false;
            }
            const submitData = formComp ? cloneDeep(formComp.getCompleteSubmissionData()) : null;
            const hasDataToSubmit = !!submitData && !isEmpty(submitData);
            if (!hasDataToSubmit) {
                console.log('form has no data');
                await this.showBlockedSubmitMessage();
                return false;
            }
            //const submitData = cloneDeep(this.currentSubmissionData);
            this.loadingSave = true;
            let success = false;  // we'll return this so caller knows status
            try {
                const saveResp = await suppliosApi.workflowTask.submit_complete_form(this.taskId, submitData);
                const taskObj = saveResp.data;  // returns the full task object
                // emit to parent right away -- it can decide to do something or not
                this.$emit('complete-form-submitted', taskObj);
                this.setTask(taskObj);
                // HANDLE STATE CHANGE??? OR OTHER BIG THINGS TO EMIT TO PARENT?
                if (showToast) {
                    this.$toast.success('Submission saved.');
                }
                // show a different success message / page?
                success = true;
            } catch (err) {
                this.apiErrorHandler(err);
                success = false;
            }
            this.loadingSave = false;
            return success;
        },
        async showBlockedSubmitMessage(msg, title) {
            const finalMsg = msg || 'There is not data to submit yet.';
            const finalTitle = title || 'Unable to submit';
            return await this.$bvModal.msgBoxOk(finalMsg, {
                title: finalTitle,
                centered: true,
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
            });  // will always return true
        },
        async showPartialDataSaveConfirm() {
            const confirmMsg = 'When you save your progress, only the complete and valid fields you have filled in are saved.  Should we proceed?';
            const proceed = await this.$bvModal.msgBoxConfirm(confirmMsg, {
                title: 'Save progress?',
                centered: true,
                size: 'sm',
                buttonSize: 'sm',
                okTitle: 'Proceed',
                cancelTitle: 'Cancel',
                okVariant: 'primary',
                cancelVariant: 'minimal-secondary',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
            });
            return proceed;  // its a boolean, will be true if they click OK, false if they cancel, null if they close modal
        },
        async submitPartialForm({showToast = false} = {}) {  // CAN ALSO CALL THIS FROM PARENT USING REF! - maybe ONLY from parent... maybe only have 'save draft' on this one
            // call validation method first?
            // GRAB FORM DATA BEFORE STARTING LOADING -- loading will destroy form in child component???
            // must get PARTIAL data here from FormioForm component -- we'll only get it when called, because it might be expensive
            const formComp = this.getFormioFormRef();
            const submitData = formComp ? cloneDeep(formComp.getPartialSubmissionData()) : null;
            const hasDataToSubmit = !!submitData && !isEmpty(submitData);
            if (!hasDataToSubmit) {
                await this.showBlockedSubmitMessage();
                return false;
            }
            const shouldProceed = await this.showPartialDataSaveConfirm();
            if (!shouldProceed) {
                return false; 
            }  // otherwise, keep going
            this.loadingSave = true;
            let success = false;  // we'll return this so caller knows status
            try {
                console.log('partial submitData', submitData);
                const saveResp = await suppliosApi.workflowTask.submit_partial_form(this.taskId, submitData);
                const taskObj = saveResp.data;  // returns the full task object
                // emit to parent right away -- it can decide to do something or not
                this.$emit('partial-form-submitted', taskObj);
                this.setTask(taskObj);
                // HANDLE STATE CHANGE??? OR OTHER BIG THINGS TO EMIT TO PARENT?
                if (showToast) {
                    this.$toast.success('Progress saved');
                }
                // show a different success message / page?
                success = true;
            } catch (err) {
                this.apiErrorHandler(err);
                success = false;
            }
            this.loadingSave = false;
            return success;
        },
        async submitDraft({showToast = false} = {}) {
            // any validation???
            // GRAB FORM DATA BEFORE STARTING LOADING -- loading will destroy form in child component???
            const submitData = cloneDeep(this.currentSubmissionData);
            this.loadingSave = true;
            let success = false;  // we'll return this so caller knows status
            try {
                const saveResp = await suppliosApi.workflowTask.submit_draft(this.taskId, submitData);
                const taskObj = saveResp.data;  // returns the full task object
                // emit to parent right away -- it can decide to do something or not
                this.$emit('draft-form-submitted', taskObj);
                this.setTask(taskObj);
                // probably nothing major to $emit to parent for saving drafts?  but maybe should if parent also has all submission data?
                if (showToast) {
                    this.$toast.success('Draft saved.');
                }
                success = true;
            } catch (err) {
                this.apiErrorHandler(err);
                success = false;
            }
            this.loadingSave = false;
            return success;
        },
        // EXTRAS
    }
}
</script>

<style>

</style>